import { render } from "./EsHome.vue?vue&type=template&id=c5a4e938"
import script from "./EsHome.vue?vue&type=script&lang=js"
export * from "./EsHome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__